import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { PDFDownloadLink } from "@react-pdf/renderer";
// import PurchaseOrderPDF from "./PurchaseOrderPDF"; // PDF Component
import PurchaseOrderForm from "./PurchaseOrderForm"; 
import PurchaseOrderPDF1 from "./PurchaseOrderPDF1"; // PDF Component

const PurchaseOrderDetails = () => {
    const { id } = useParams(); // Get purchaseorder ID from URL
    const [purchaseorder, setPurchaseOrder] = useState(null); // State to hold the purchaseorder data
    const navigate = useNavigate();
    const [purchaseorderTerms, setPurchaseOrderTerms] = useState("");
    const [companyDetails, setCompanyDetails] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [quotationNotes, setQuotationNotes] = useState("");


    const fetchCompanyDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/settings`, {
                headers: { Authorization: `Bearer ${token}`,
                'Tenant-Origin': origin,
            },
            });

            setCompanyDetails(response.data.setting);
        } catch (error) {
            console.error("Error fetching company details:", error);
        }
    };
    const handleEmailSend = async (purchaseorderId) => {
        try {
            console.log("Sending email for purchase order ID:", purchaseorderId);  // Add this line for debugging
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const response = await axios.post(
                `${backendUrl}/api/purchase-order/send-email/${purchaseorderId}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                }
            );
            console.log(response.data.message);
            alert("Email sent successfully.");
        } catch (error) {
            console.error("Error sending email:", error);
            alert("Failed to send email.");
        }
    };
    
    // Fetch purchaseorder data from API
    const fetchPOById = async (purchaseorderId) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL; // Backend base URL
            const userInfo = JSON.parse(localStorage.getItem("user-info")); // Retrieve user info from localStorage
            const token = userInfo?.token; // Extract token
            const origin = localStorage.getItem('user-origin');

            const response = await axios.get(
                `${backendUrl}/api/purchase-order/${purchaseorderId}`,
                {
                    headers: { Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                }
            );
            console.log("API Response:", response.data);

            return response.data.purchaseorder; // Return the purchaseorder data
        } catch (error) {
            console.error(`Error fetching purchaseorder with ID ${purchaseorderId}:`, error);
            return null; // Return null if error occurs
        }
    };
    // const fetchPurchaseOrderTerms = async (currency) => {
    //     try {
    //         const backendUrl = process.env.REACT_APP_BACKEND_URL;
    //         const userInfo = JSON.parse(localStorage.getItem("user-info"));
    //         const token = userInfo?.token;

    //         const response = await axios.get(`${backendUrl}/api/quotationterm`, {
    //             headers: { Authorization: `Bearer ${token}` },
    //         });

    //         const term = response.data.quotation_terms.data.find(
    //             (term) => term.type === "purchase_order"
    //         );
    //         const formattedTerms = term?.value.replace(/{{currency}}/g, currency || "USD");
    //         console.log("Formatted Terms with Currency:", formattedTerms);

    //         setPurchaseOrderTerms(formattedTerms || ""); // Set terms
    //         setQuotationNotes(formattedTerms);
    //     } catch (error) {
    //         console.error("Error fetching purchaseorder terms:", error);
    //     }
    // };
    useEffect(() => {
        const loadPurchaseOrder = async () => {
            const fetchedPO = await fetchPOById(id);
            console.log("Fetched Purchase Order Data:", fetchedPO); // Debugging log
    
            if (fetchedPO) {
                setPurchaseOrder(fetchedPO);
    
                // Extract the currency from the first product's vendor details
                const currency =
                    fetchedPO.product_item_details[0]?.product?.vendor?.currency || "USD"; // Fallback to "USD" if undefined
    
                console.log("Extracted Currency:", currency); // Debugging log
                // await fetchPurchaseOrderTerms(currency); // Pass the extracted currency
                setQuotationNotes(fetchedPO.notes); 

            }
        };
    
        fetchCompanyDetails();
        loadPurchaseOrder();
    }, [id]);
    
    const handleBackClick = () => {
        navigate(-1);
    };
  
    const handleEditClick = () => {
        if (purchaseorder && purchaseorder.quotation_id) {
            console.log("quou:",purchaseorder.quotation_id)
            setIsEditModalOpen(true); // Open the modal only if purchaseorder data and quotation_id are available
        } else {
            console.error("Quotation ID is missing.");
        }
    };
    
    
    const closeEditModal = () => {
        setIsEditModalOpen(false); // Close the modal
    };
    // Show loading message while fetching data
    if (!purchaseorder) return <div>Loading...</div>;
    const hasDiscount = purchaseorder.discount_amount && purchaseorder.discount_amount > 0;

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Page Title */}
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">PurchaseOrder Details</h4>
                                <div className="page-title-right">

                                    <div className="page-title-right d-flex align-items-center">
                                    <button style={{
                                            padding: "6px 16px",
                                            backgroundColor: "#415094",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "4px",
                                            cursor: "pointer",
                                            fontSize: "14px",}}
                                             className="btn btn-warning" onClick={handleEditClick}>
                                        Edit
                                    </button>&nbsp;&nbsp;
                                        <PDFDownloadLink
                                            document={<PurchaseOrderPDF1 purchaseorder={purchaseorder} quotationNotes={quotationNotes} purchaseorderTerms={purchaseorderTerms} companyDetails={companyDetails} />}
                                            fileName={`${purchaseorder.ref_no}.pdf`}
                                        >
                                            {({ loading }) => (
                                                <button
                                                    style={{
                                                        padding: "6px 16px",
                                                        backgroundColor: "#415094",
                                                        color: "#fff",
                                                        border: "none",
                                                        borderRadius: "6px",
                                                        cursor: "pointer",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    {loading ? " " : "Download"}
                                                </button>
                                            )}
                                        </PDFDownloadLink>&nbsp;&nbsp;
                                        <button style={{
                                            padding: "6px 16px",
                                            backgroundColor: "#415094",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "4px",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                        }}
                                        onClick={() => handleEmailSend(purchaseorder.id)} className="btn btn-secondary  back">Send</button>
                                        {/* </div> */}
                                        &nbsp;&nbsp;
                                        <button style={{
                                            padding: "6px 16px",
                                            backgroundColor: "#415094",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "4px",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                        }}
                                            onClick={handleBackClick} className="btn btn-secondary  back">Back</button>
                                        {/* </div> */}
                                        &nbsp;&nbsp;
                                    
                                    </div>
                                </div>
                            </div>
                        </div> </div>


                    {/* A4 PurchaseOrder Layout */}
                    <div style={styles.page}>
                        {/* Header Section */}
                        <div style={styles.header}>
                            <div>
                                <h2 style={styles.companyName}>{companyDetails?.company_name}</h2>
                                <p style={styles.companyDetails}>
                                    {companyDetails?.phone} <br />
                                    {companyDetails?.email}<br />
                                    <p dangerouslySetInnerHTML={{ __html: companyDetails?.company_address }} />
                                    </p>
                            </div>
                            <div style={styles.topRight}>
                                <img
                                    src="/images/655c8bbb23be8.png" // Provide the image source
                                    alt="Company Logo"
                                    style={styles.image}
                                />



                                <div style={styles.purchaseorderTitle}>Purchaseorder</div>
                            </div>
                        </div><hr style={styles.hr} />

                        {/* PurchaseOrder Details */}
                        <div style={styles.detailsSection}>
                        <div>
                            <p>
                                <strong>To,</strong>
                            </p>
                <p>
                {purchaseorder.product_item_details[0]?.product?.vendor?.name || "Vendor not available"}
                </p>
                
                <p>
                {purchaseorder.product_item_details[0]?.product?.vendor?.mobile || " "}                
                </p>
                <p>
                {purchaseorder.product_item_details[0]?.product?.vendor?.email || " "}                
                </p>
                <p>
                {purchaseorder.product_item_details[0]?.product?.vendor?.address || " "}                
                </p>
              </div>
                            <div>
                                <p>
                                    <strong>PO #:&nbsp;</strong>{purchaseorder.ref_no || " "}
                                </p>
                                <p>
                                    <strong>Date:&nbsp;</strong>{purchaseorder.date || ""}
                                </p>
                               
                            </div>
                        </div><br /><br />

                        {/* Table Section */}
                        <table style={styles.table}>
                            <thead>
                                <tr>
                                    <th style={styles.tableHeader}>No</th>
                                    <th style={styles.tableHeader}>Product</th>
                                    <th style={styles.tableHeader}>Description</th>
                                    <th style={styles.tableHeader}>Price</th>
                                    <th style={styles.tableHeader}>QTY</th>
                                    <th style={styles.tableHeader}>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {purchaseorder.product_item_details && purchaseorder.product_item_details.length > 0 ? (
                                    purchaseorder.product_item_details.map((item, index) => (
                                        <tr key={index}>
                                            <td style={styles.tableCell}>{index + 1}</td>
                                            <td style={styles.tableCell}>{item.item_name || " "}</td>
                                            <td style={styles.tableCell}>
                                                {item.item_description || ""}
                                            </td>
                                            <td style={styles.tableCell}>{item.price || ""}</td>
                                            <td style={styles.tableCell}>{item.quantity || ""}</td>
                                            <td style={styles.tableCell}>{item.subtotal || ""}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td
                                            colSpan="6"
                                            style={{
                                                textAlign: "center",
                                                padding: "10px",
                                                fontStyle: "italic",
                                            }}
                                        >
                                            No items available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {/* Footer Section */}
                        <div style={styles.footer}>
                            {hasDiscount && (
                                <div>
                                    <p>
                                        <strong>One Time Discount{purchaseorder.discount_type === 'percentage' ? ' (%)' : ''}:</strong>&nbsp; {purchaseorder.discount_amount || ""}
                                    </p>
                                </div>
                            )}
                            <p>
                                <strong>Total Amount:</strong> {purchaseorder.amount || ""}
                            </p><br /><br /><br />
                            {/* {purchaseorderTerms && (
                                <div style={styles.terms}>
                                    <div dangerouslySetInnerHTML={{ __html: purchaseorderTerms }} />


                                </div>
                            )} */}
                            <div style={styles.terms}>
                                {purchaseorder.notes && (
                                    <div>
                                        <div dangerouslySetInnerHTML={{ __html: purchaseorder.notes }} />
                                    </div>
                                )}
                            </div>
                        </div>
                        <div style={styles.signfooter}>
                            <div style={styles.signatureSection}>
                                {["Stamp", "Authorized"].map((role, index) => (
                                    <div key={index} style={styles.signatureBlock}>
                                        <p>--------------------------</p> {/* Placeholder line */}
                                        <p style={{ marginBottom: 0, lineHeight: "14px" }}>{role}</p>
                                        <p>{role === "Stamp" ? "" : "Signature"}</p>
                                    </div>
                                ))}
                                  
                            </div>
                            {console.log("Purchase order data before passing to modal:", purchaseorder)}

                            {purchaseorder ? (
    isEditModalOpen && (
        <PurchaseOrderForm
            showModal={isEditModalOpen}
            handleClose={closeEditModal}
            purchaseorderData={purchaseorder} // Pass the data here
            poId={id}
            setPurchaseOrder={setPurchaseOrder}

        />
    )
) : (
    <div>Loading...</div> // Show loading while fetching data
)}

                        </div>
                    </div>
                </div>
            </div>
        </div>
      
    );
};


export default PurchaseOrderDetails;

// Inline Styles for A4 Layout
const styles = {
    page: {
        width: "210mm",
        minHeight: "200mm",
        margin: "0 auto",
        padding: "10mm",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#ffffff",
        border: "1px solid #ddd",
        fontSize: "12px",
        borderRadius: "12px"
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        // marginBottom: "20px",
    },
    companyName: {
        fontSize: "18px",
        fontWeight: "bold",
        color: "#415094",
    },

    companyDetails: {
        fontSize: "14px",
        // marginTop: "5px",
        color: "#415094",

    },
    purchaseorderTitle: {
        fontSize: "24px",
        color: "#415094",
        marginBottom: "30px",

        marginLeft: "10px",
        lineHeight: ".4",
        // Add some margin between the image and the title
    },
    headerRight: {
        display: "flex",  // Make the container a flexbox to align the image and title side by side
        alignItems: "center", // Vertically align the content in the center
    },
    topRight: {
        alignSelf: "start",
        textAlign: "right",
    },
    Right: {
        alignSelf: "start",
        textAlign: "right",
        marginTop: "20px",
    },
    image: {

        objectFit: "contain",
        marginBottom: "20px",
        maxWidth: "214px",
        maxHeight: "100px",


    },
    hr:{
       marginTop: "-7px"
    },
    detailsSection: {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "10px",
        // marginTop: "10px",
        lineHeight: "1",
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
        marginBottom: "20px",
        lineHeight: "3",

    },
    tableHeader: {
        borderBottom: "1px solid #ddd",
        padding: "8px",
        textAlign: "left",
        fontWeight: "bold",
    },
    tableCell: {
        borderBottom: "1px solid #ddd",
        padding: "8px",
        textAlign: "left",
    },
    footer: {
        marginTop: "30px",
        textAlign: "right",
    },
    terms: {
        fontSize: "12px",
        marginTop: "20px",
        textAlign: "left",
    },
    signfooter: {
        marginTop: "150px",
        textAlign: "center",

    },
    signatureSection: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        marginTop: "20px",
    },
    signatureBlock: {
        textAlign: "center",
    },
    signatureImage: {
        width: "120px",
        height: "50px",
        objectFit: "contain",
        marginBottom: "10px",
    },
};
